<template>
  <back-new-year v-if="newYear" :height="height" />
  <v-sheet v-else
      class="back"
      :style="{height:height+'px'}"
      :color="$mainColor"
  >

    <div class="background">
      <span v-for="i in 10" :key="i" class="rain"></span>
    </div>
  </v-sheet>
</template>

<script>
import moment from "moment";
import BackNewYear from "@/componentsV2/base/BackNewYear.vue";

export default {
  components: {BackNewYear},
  props: ['height'],
  data:()=>({
    newYear:false,
  }),
  mounted() {
    const m = moment();
    const month = m.month();
    const day = m.date();
    if((month === 11 && day >= 20) || (month === 0 && day <= 10))
      this.newYear = true;
  }
}
</script>

<style lang="scss" scoped>
.back {
  top:0;
  left:0;
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  z-index: -1;

  $animationtime: 60*4s;
  $length: 10;

  .rain {
    height: 100vh;
    width: 0;
    top: 0;
    position: absolute;
    transform-origin: top right;
    transform: rotate(25deg);
    @for $i from 1 through $length {
      &:nth-child(#{$i}) {
        $min: 40;
        $max: 400;
        width: #{$min + random($max - $min)+'px'};
        background-color: rgba(255, 255, 255, 0.04);
        animation: #{$animationtime - $animationtime / $length / 2 *$i}
        linear
        infinite
        slide;
        animation-delay: -#{$i / $length * $animationtime};
      }
    }
  }
  @keyframes slide {
    from {
      left: -25vw;
    }
    to {
      left: 125vw;
    }
  }
}
</style>